import INotificationsRepository from 'domain/interfaces/repositories/INotificationsRepository'
import { CreateNotificationsAsReadQueryRequest } from 'domain/entities/notifications'

export const CreateNotificationAsReadCommand = (
  repository: INotificationsRepository,
  data: CreateNotificationsAsReadQueryRequest,
) => {
  return repository.markAsRead(data)
}
